import { render, staticRenderFns } from "./AgentPoint.vue?vue&type=template&id=053cab48"
import script from "./AgentPoint.vue?vue&type=script&lang=js"
export * from "./AgentPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports